import { AlkLogger, ILocalPersistence } from '@alk/core';
import { ERoutes } from '../../enums';
import { fromEvent, merge, Observable, Subject } from 'rxjs';
import { inject, injectable } from 'inversify';
import { IRouterListenerService } from './router-listener.interface';
import { LOCAL_PERSISTENCE_SERVICE } from '../symboles.ioc';
import { map } from 'rxjs/operators';

const SFX_ROUTE_TAB = 'SFX_ROUTE_TAB';
const FILTER_MAIN_WORKSPACE_TABS = `(${ '/trading' }|${ '/reports' })`;

@injectable()
export class RouterListenerService implements IRouterListenerService {

    private URLChange$: Observable<string>;

    @inject(LOCAL_PERSISTENCE_SERVICE) private readonly _storage: ILocalPersistence;

    init(): void {
        AlkLogger.info('RouterListenerService created');

        const popState$ = this.getPopState$();
        const pushState$ = this.getPushState$();

        popState$.subscribe(AlkLogger.info.bind(null, 'popState$'));
        pushState$.subscribe(AlkLogger.info.bind(null, 'pushState$'));

        this.URLChange$ = merge(popState$, pushState$);
        this.subscribeStoringLastVisitFromComponent(SFX_ROUTE_TAB, RegExp(FILTER_MAIN_WORKSPACE_TABS));
    }

    subscribeStoringLastVisitFromComponent(storeLabel: string, regExp: RegExp): void {
        this.URLChange$.subscribe(url => {
            if (regExp.test(url)) {
                this._storage.setItem(storeLabel, url);
                AlkLogger.info(`saved ${ url } into ${ storeLabel }`);
            }
        });
    }

    getStoredRoute(): Promise<ERoutes> {
        return Promise.resolve(this._storage.getItem(SFX_ROUTE_TAB) as ERoutes || '/trading');
    }

    getPushState$(): Observable<string> {
        const subject$ = new Subject<string>();
        const realPushState = history.pushState;
        history.pushState = (...args) => {
            AlkLogger.info(...args);
            subject$.next(args[ 2 ] as string);
            return realPushState.apply(history, args);
        };

        return subject$.asObservable();
    }

    getPopState$(): Observable<string> {
        const onhashchange$: Observable<Event> = fromEvent<Event>(window, 'popstate');
        onhashchange$.subscribe(AlkLogger.info);
        return onhashchange$.pipe(map(() => location.pathname));
    }
}
